
      import API from "!../../../../client/web/myagent/app/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../client/web/myagent/app/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../client/web/myagent/app/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../client/web/myagent/app/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../client/web/myagent/app/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../client/web/myagent/app/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!./ConfirmDialog.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!./ConfirmDialog.css";
       export default content && content.locals ? content.locals : undefined;
